import { NgModule } from '@angular/core';
import { AppRouting } from './app.routes';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {ReactiveFormsModule} from '@angular/forms';
import 'bootstrap';
import {AppError} from './theme/components/app-error/error.component';
/*
 * Platform and Environment providers/directives/pipes
 */
import { environment } from 'environments/environment';

// App is our top level component
import { AppComponent } from './app.component';
 import { ThemeModule } from './theme/theme.module';
import { ModalModule } from 'ngx-modialog';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';


//autocomplete
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';




import './app.scss';

// Application wide providers
 


/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
	bootstrap: [
		 AppComponent
	],

	declarations: [ 
		AppComponent ,
		AppError,
	],

	/**
	 * Import Angular's modules.
	 */
	imports: [

		AppRouting,
		BrowserModule,
 		//BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		HttpClientModule,
		ModalModule.forRoot(),
		BootstrapModalModule,
		CommonModule,

		MatFormFieldModule, //---
		MatInputModule,		// :)
		MatAutocompleteModule, //--
		

		BrowserAnimationsModule, // required animations module 
		// RouterModule.forRoot( ROUTES, {

		//     useHash: Boolean( history.pushState ) === false,
		//     preloadingStrategy: PreloadAllModules

		// } ),

		ThemeModule.forRoot(),

		/**
		 * This section will import the `DevModuleModule` only in certain build types.
		 * When the module is not imported it will get tree shaked.
		 * This is a simple example, a big app should probably implement some logic
		 */
		
		 // ...environment.showDevModule ? [DevModuleModule] : []

	],

	/**
	 * Expose our Services and Providers into Angular's dependency injection.
	 */
	providers: [
		
		environment.ENV_PROVIDERS,
	]

})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts